// Everything a rewrite touches lives here, so the render code below never needs edits.
// Replace the placeholder entries — they exist to show the shape, not to be shipped.

export const projects = [
  {
    title: 'Placeholder Project One',
    blurb: 'What it does, in one sentence. What was hard about it, in the next.',
    tags: ['aws', 'terraform'],
    href: null,
    year: 2026,
  },
  {
    title: 'Placeholder Project Two',
    blurb: 'A short, concrete description beats an abstract one every time.',
    tags: ['javascript', 'frontend'],
    href: null,
    year: 2025,
  },
  {
    title: 'Placeholder Project Three',
    blurb: 'Link it if it is public; leave href null and the card renders unlinked.',
    tags: ['python'],
    href: null,
    year: 2025,
  },
];

export const posts = [
  { title: 'A post you have not written yet', date: '2026-01-15', href: null },
  { title: 'Another one', date: '2025-11-02', href: null },
];

export const links = [
  { label: 'Email', value: 'jdwright@hey.com', href: 'mailto:jdwright@hey.com' },
  { label: 'GitHub', value: 'github.com/jdwright', href: 'https://github.com/jdwright' },
];
